import { useState } from 'react';
import { CSSTransition } from 'react-transition-group';
import { useMounted, useUnmount } from '@/utils/hooks';
import { fixedBody, looseBody } from '@/utils/fn';
import styles from '../style.less';

const QRCodeModal = ({ imgName, groupName, handleClose }) => {
  const [inProp, setInProp] = useState(false);

  useMounted(() => {
    fixedBody();
    setTimeout(() => setInProp(true), 200);
  });

  useUnmount(() => {
    looseBody();
  });
  return (
    <div className={styles.modal} onClick={handleClose}>
      <CSSTransition in={inProp} timeout={200} classNames="fade" mountOnEnter unmountOnExit>
        <div className={styles.modalContent} onClick={e => e.stopPropagation()}>
          <h3 className={styles.logo}>网心云</h3>
          <div className={`${styles.qrcode} ${styles[imgName]}`} />
          <p className={styles.groupName}>{groupName}</p>
          <div className={styles.footer}>截图至微信扫一扫即可加入</div>
        </div>
      </CSSTransition>
    </div>
  );
};
export default QRCodeModal;
